import { Link, Typography } from '@ace-clublabs/shared-component-library';
import { constants } from '@/constants';

export interface TermsAndConditionsProps {
  buttonLabel?: string;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  buttonLabel = 'Next',
}) => {
  return (
    <Typography
      variant='b3Regular'
      sx={{
        textAlign: 'left',
        mt: 1,
      }}
    >
      By selecting "{buttonLabel}", I agree to receive future calls and texts
      (collectively “calls”) on my mobile number from AAA (or on AAA's behalf)
      regarding my travel bookings, membership and other offers. Message
      frequency varies, message and data rates may apply. These calls may use an
      automatic telephone dialing system, a prerecorded voice message, or text
      message. Reply HELP for help or STOP to unsubscribe from text messages.
      Providing my consent is not a condition to the purchase of any AAA goods
      or services. By consenting, I agree to our{' '}
      <Link href={constants.PRIVACY_NOTICE_URL} target='_blank'>
        Privacy Policy
      </Link>
      ,{' '}
      <Link href={constants.TERMS_AND_CONDITIONS_URL} target='_blank'>
        Terms & Conditions
      </Link>
      ,{' '}
      <Link href={constants.TEXT_TERMS_URL} target='_blank'>
        TextTerms
      </Link>
      .
    </Typography>
  );
};

export default TermsAndConditions;
